module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/referral-hero-11ef60f479b8da0e.png"+" 1024w",
        images: [{path: __webpack_public_path__ + "assets/images/referral-hero-11ef60f479b8da0e.png",width: 1024,height: 1024}],
        src: __webpack_public_path__ + "assets/images/referral-hero-11ef60f479b8da0e.png",
        toString: function(){return __webpack_public_path__ + "assets/images/referral-hero-11ef60f479b8da0e.png"},
        
        width: 1024,
        height: 1024
      }